import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPredictions,
  updatePredictions,
  getPredictionById,
} from "api/predictions.api";

export const getPredictionsAsync = createAsyncThunk(
  "predictions/get-all",
  async (filters) => {
    const data = await getPredictions(undefined, filters);
    return data;
  },
);

export const getNextPredictionsAsync = createAsyncThunk(
  "predictions/get-all-next",
  async ({ last, filters }) => {
    const data = await getPredictions(last, filters);
    return data;
  },
);

export const getPredictionByIdAsync = createAsyncThunk(
  "prediction/get-by-id",
  async (id) => {
    const prediction = await getPredictionById(id);
    const response = await fetch(prediction.content);
    const text = await response.text();
    return { ...prediction, content: text };
  },
);

export const updatePredictionAsync = createAsyncThunk(
  "prediction/update",
  async ({ id, data }) => {
    await updatePredictions(id, data);
  },
);
